'use strict';


module.exports = {
	NEW: 'new',
	NON_SUBSCRIBED: 'non-subscribed',
	SUBSCRIBED: 'subscribed'
};